module.exports = __webpack_public_path__ + "img/214.problem_broken_toilet_handle.2dd638ff.svg";